import {WithPermissionModel} from '../../../../../../../common/permission/api/entity/withPermission.model';
import {
    CommunicationConfigurationEmailModel
} from '../../../../../../../communication/configuration/email/common/api/model/communicationConfigurationEmail.model';
import {LovValueSummary} from '../../../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {SaleInvoiceConfigurationBookModel} from "./saleInvoiceConfigurationBook.model";

export class SaleInvoiceConfigurationModel extends WithPermissionModel {

    id: number;
    invoiceGenerationHideFreeProduct: boolean;
    invoiceGenerationHideZeroAmount: boolean;
    invoiceGenerationIgnoreVat: boolean;
    invoiceRegenerationOnPayment: boolean;
    invoiceIncludeAddress: boolean;

    includePaymentRequests: boolean;
    emailConfiguration: CommunicationConfigurationEmailModel;
    invoiceType: LovValueSummary;

    purchaseOrderEmailConfiguration: CommunicationConfigurationEmailModel;
    purchaseOrderValidationDurationDays: number;
    purchaseOrderAutoGeneration: boolean;
    purchaseOrderRequestSignature: boolean;

    autoGeneration: boolean;
    books: SaleInvoiceConfigurationBookModel[] = [];
}
